(() => {
  if (customElements.get('diamond-education')) return;
  class DiamondEducation extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelectorAll('[role="tablist"]').forEach(list => {
        const tabs = [...list.querySelectorAll('[role="tab"]')];
        const select = (tab, focus = false) => {
          tabs.forEach(item => {
            const active = item === tab;
            item.setAttribute('aria-selected', String(active));
            item.tabIndex = active ? 0 : -1;
            const panel = this.querySelector(`[id="${item.getAttribute('aria-controls')}"]`);
            if (panel) panel.hidden = !active;
          });
          if (focus) tab.focus();
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => select(tab));
          tab.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;
            if (next !== undefined) { event.preventDefault(); select(tabs[next], true); }
          });
        });
      });
      this.querySelectorAll('.de-chapters a, .de-hero .de-button').forEach(link => {
        link.addEventListener('click', event => {
          const hash = link.getAttribute('href');
          const destination = hash && this.querySelector(`[id="${hash.slice(1)}"]`);
          if (!destination) return;
          event.preventDefault();
          destination.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
          destination.setAttribute('tabindex', '-1');
          destination.focus({preventScroll: true});
          history.replaceState(null, '', hash);
        });
      });
    }
  }
  customElements.define('diamond-education', DiamondEducation);
})();
